export default keywords => {
  return Object.keys(keywords).reduce((sum, key) => {
    if (!sum) return `?${key}=${keywords[key]}`

    if (keywords[key]) return `${sum}&${key}=${keywords[key]}`

    return sum
  }, '')
}
